export default {
  container: `
  `,
  row: `
    display: flex;
    flex-direction: row;
    align-items: center;
  `
}